import { useTranslation } from "react-i18next";
import useTenantLogo from "hooks/useTenantLogo";

/**
 * The logo in the corner of the sign-in screens (login and the password-reset
 * steps). The tenant's own logo when one is uploaded — one image for every
 * breakpoint, bounded by height and width with `object-contain` so a wide or
 * tall logo keeps its proportions — otherwise the Amer pair: the white mark on
 * the phone layout, the theme-dependent one beside the form on desktop.
 */
const LoginBrandLogo = ({ isDark }) => {
  const { t } = useTranslation();
  const tenantLogo = useTenantLogo();

  if (tenantLogo) {
    return (
      <img
        src={tenantLogo}
        alt={t("generalSet.tenantLogo.label")}
        className="login-logo absolute start-[17px] sm:start-8 lg:start-[72px] top-[35px] sm:top-8 lg:top-[72px] z-50 h-auto w-auto max-h-[48px] max-w-[120px] lg:max-h-[80px] lg:max-w-[180px] object-contain"
      />
    );
  }

  return (
    <>
      <img
        src="/amer-login-logo.svg"
        alt="Amer logo"
        height={63.607}
        width={90.277}
        className="login-logo absolute start-[17px] sm:start-8 lg:hidden top-[35px] sm:top-8 z-50 w-[77.36px]"
      />
      <img
        src={isDark ? "/amer-login-logo.svg" : "/d-amer-login-logo.svg"}
        alt="Amer logo"
        height={63.607}
        width={90.277}
        className="login-logo absolute hidden lg:block lg:start-[72px] lg:top-[72px] z-50 lg:w-[130px]"
      />
    </>
  );
};

export default LoginBrandLogo;
